var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onPlayerClick.apply(null, arguments)}}},[_c('div',{attrs:{"id":"videoPlayer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }